import type { Pinia } from "pinia";

import BaseService from "~/services/BaseService";
import { useAuthModule } from "~/stores/auth";

/** Gives every Nuxt app (one per SSR request, one in the browser) its own `BaseService`. */
export default defineNuxtPlugin({
  name: "api",
  dependsOn: ["pinia"],
  setup(nuxtApp) {
    const pinia = nuxtApp.$pinia as Pinia;
    const api = new BaseService({
      accessToken: () => useAuthModule(pinia).token?.access_token ?? undefined,
      logout: () => useAuthModule(pinia).logout(),
    });

    if (import.meta.client)
      BaseService.setClientInstance(api);

    return { provide: { api } };
  },
});
